import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface AIDisclaimerModalProps {
  open: boolean;
  onAccept: () => void;
  onGoBack: () => void;
  isStartupMode?: boolean;
}

export const AIDisclaimerModal: React.FC<AIDisclaimerModalProps> = ({
  open,
  onAccept,
  onGoBack,
  isStartupMode = false,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={isStartupMode ? undefined : onGoBack}
      disableEscapeKeyDown={isStartupMode}
      aria-labelledby="ai-disclaimer-title"
      aria-describedby="ai-disclaimer-description"
      sx={{ minWidth: "400px" }}
    >
      <DialogTitle id="ai-disclaimer-title" sx={{ minWidth: "400px" }}>
        {t("general.ai_disclaimer.title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="ai-disclaimer-description">{t("general.ai_disclaimer.message")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" data-testid="ai-disclaimer-go-back" onClick={onGoBack}>
          {isStartupMode ? t("general.ai_disclaimer.switch_to_english") : t("general.ai_disclaimer.go_back")}
        </Button>
        <Button variant="contained" data-testid="ai-disclaimer-accept" onClick={onAccept}>
          {t("general.ai_disclaimer.accept")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
